import { useDebouncedCallback } from 'use-debounce';
import { useEffect } from 'react';

const useDebounce = <T extends (...args: any[]) => any>(
  callback: T,
  delay: number
): T => {
  const debounced = useDebouncedCallback(callback, delay);

  useEffect(() => () => {
      debounced.cancel?.();
    }, [debounced]);

  return debounced as unknown as T;
};

export default useDebounce; 
